module.exports = __webpack_public_path__ + "static/media/LaraCroft.948576be.jpg";